import { jsxs, jsx } from "react/jsx-runtime";
const IconInfoSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 1C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1Zm0 20c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9Z" }),
      /* @__PURE__ */ jsx("path", { d: "M12 10h-2v2h1v6h2v-7a1 1 0 0 0-1-1Zm.38-3.92a1 1 0 0 0-.76 0c-.12.05-.23.12-.33.21-.18.19-.29.45-.29.71 0 .07.01.13.02.2.01.06.03.12.06.18.02.06.05.12.09.18l.12.15c.1.09.21.16.33.21.12.06.25.08.38.08s.26-.02.38-.08c.13-.05.23-.12.33-.21.04-.05.09-.1.12-.15.04-.06.07-.12.09-.18.03-.06.05-.12.06-.18.02-.07.02-.13.02-.2 0-.26-.1-.52-.29-.71-.1-.09-.2-.16-.33-.21Z" })
    ]
  }
);
export {
  IconInfoSvg
};
